import React, { useEffect, useState } from 'react';
import { Mail } from 'lucide-react';
import axiosInstance from '../../api/api';

export default function NewsletterStatsCard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axiosInstance.get('/newsletter/stats')
      .then((r) => setStats(r.data))
      .catch(() => setStats(null));
  }, []);

  if (!stats) return null;
  const max = Math.max(1, ...stats.weekly_trend.map((w) => w.count));

  return (
    <div className="bg-white rounded-xl shadow-md p-6" data-testid="newsletter-stats-card">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
          <Mail className="h-5 w-5 text-orange-500" />
          Newsletter Subscribers
        </h3>
        <span className="text-sm text-green-600 font-medium" data-testid="newsletter-week-growth">
          +{stats.new_this_week} this week
        </span>
      </div>
      <div className="flex items-end gap-6">
        <div>
          <p className="text-3xl font-bold text-gray-900" data-testid="newsletter-active-count">{stats.active}</p>
          <p className="text-gray-500 text-sm">Active subscribers</p>
          {stats.total !== stats.active && (
            <p className="text-xs text-gray-400 mt-1">{stats.total - stats.active} unsubscribed</p>
          )}
        </div>
        <div className="flex-1">
          <div className="flex items-end gap-1 h-20" data-testid="newsletter-trend-bars">
            {stats.weekly_trend.map((w, i) => (
              <div key={i} className="flex-1 flex flex-col items-center justify-end" title={`Week of ${w.week_start}: ${w.count}`}>
                <span className="text-[10px] text-gray-500 mb-0.5">{w.count > 0 ? w.count : ''}</span>
                <div
                  className={`w-full rounded-t ${i === stats.weekly_trend.length - 1 ? 'bg-orange-500' : 'bg-orange-200'}`}
                  style={{ height: `${Math.max(4, (w.count / max) * 60)}px` }}
                />
              </div>
            ))}
          </div>
          <p className="text-[10px] text-gray-400 text-center mt-1">Signups per week · last 8 weeks</p>
        </div>
      </div>
    </div>
  );
}
